import { getContainer } from '@framework/di/getContainer';
import MessageManager from './MessageManager';

const useMessageManager = () => {
  const container = getContainer();
  const messageManager = container.get<MessageManager>(MessageManager);

  return {
    getErrorMessage: messageManager.getErrorMessage.bind(messageManager) as typeof messageManager.getErrorMessage,
    getMessageByErrorCode: messageManager.getMessageByErrorCode.bind(
      messageManager,
    ) as typeof messageManager.getMessageByErrorCode,
    getMessageByName: messageManager.getMessageByName.bind(messageManager) as typeof messageManager.getMessageByName,
  };
};

export default useMessageManager;
